import { createContext } from "preact";

export const IdPrefixContext = createContext('');
